module.exports = __webpack_public_path__ + "img/44.5.COD.8c546328.png";